<template>
  <div :class="[$style.notification, $style.activityLiked]">
    <div :class="[$style.main, { [$style.open]: moreDetailsVisible }]">
      <a
        :href="formatUrl(notification.url)"
        :class="$style.header"
        :target="linkTarget"
      >
        <img
          :src="photoUrl(notification.user.photoUrl)"
          :title="notification.user.name"
          alt=""
        />
        <i class="fa fa-thumbs-up"></i>
        <span>{{ notification.title }}</span>
      </a>
      <span
        v-if="notification.context"
        :class="$style.toggleMoreDetails"
        @click="toggleMoreDetails"
        ><i class="fa fa-angle-left"></i
      ></span>
      <span :class="$style.timer">{{ timer }}</span>
      <div v-if="notification.context" :class="$style.moreDetails">
        <div :class="$style.moreDetailsInner">
          <p :class="$style.moreDetailsBody">
            {{ notification.context }}
            <br /><a :href="formatUrl(notification.url)" :target="linkTarget"
              ><i class="fa fa-play"></i> listen back</a
            >
          </p>
        </div>
      </div>
    </div>
    <a
      @click.prevent="readNotification(notification)"
      href="#"
      :class="$style.markAsRead"
      data-toggle="tooltip"
      data-placement="left"
      title="mark as read"
    >
      <font-awesome-icon :icon="faTrashAlt" />
    </a>
  </div>
</template>

<script>
import Notification from "./notification";

export default {
  mixins: [Notification],
};
</script>

<style module lang="less" src="./notification.less"></style>



// WEBPACK FOOTER //
// activity-liked.vue?54d18911